module.exports = __webpack_public_path__ + "static/img/cj15.e19e30f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cj15.png
// module id = 157
// module chunks = 0